/**
 * Bolt-oldali kategória-linkek: a főoldali „Alkalom” csempék (és régebbi
 * linkek) `?occasion=<kulcs>` paramétert használnak — ezeket a meglévő
 * „Események” alkategóriák slugjaira képezzük le, így az alkalom-oldal a
 * kategóriába (elsődlegesen vagy további kategóriaként) sorolt termékeket
 * mutatja.
 */

/** Alkalom-kulcs → kategória-slug (a 0003-as migráció „Események” alkategóriái). */
export const OCCASION_CATEGORY_SLUGS: Record<string, string> = {
  szulinap: 'szuletesnapra',
  szuletesnap: 'szuletesnapra',
  karacsony: 'karacsonyra',
  'anyak-napja': 'anyak-napjara',
  'apak-napja': 'apak-napjara',
  ballagas: 'ballagasra',
  eskuvo: 'eskuvore',
  legenybucsu: 'legenybucsura',
  leanybucsu: 'leanybucsura',
  valentin: 'szerelmeseknek',
  szerelmeseknek: 'szerelmeseknek',
};

/** Az alkalom-kulcs kategória-slugja; ismeretlen kulcsnál maga a kulcs (hátha slug). */
export const occasionToCategorySlug = (occasion: string | null | undefined): string => {
  const key = (occasion ?? '').trim().toLowerCase();
  if (!key) return '';
  return OCCASION_CATEGORY_SLUGS[key] ?? key;
};

interface ParamsLike {
  get(name: string): string | null;
}

/** A terméklista kategóriája az URL-ből: `?category=` elsőbbséget élvez, különben `?occasion=`. */
export const categorySlugFromParams = (params: ParamsLike): string =>
  params.get('category') || occasionToCategorySlug(params.get('occasion'));

/** Link a kategória terméklistájára. */
export const categoryHref = (slug: string): string => `/termekek?category=${encodeURIComponent(slug)}`;

/** A `?type=` paraméter normalizált slugja (üres, ha nincs). */
export const typeSlugFromParams = (params: ParamsLike): string => (params.get('type') ?? '').trim().toLowerCase();

/** Akciós szűrő az URL-ből: `?on_sale=1` (a régi `?onSale=1` linkeket is elfogadja). */
export const onSaleFromParams = (params: ParamsLike): boolean =>
  ['1', 'true', 'yes'].includes((params.get('on_sale') ?? params.get('onSale') ?? '').trim().toLowerCase());

export interface ProductTypeRef {
  slug: string;
  name: string;
}

/**
 * A típus-chip címkéje az API típuslistájából (`/product-types/`):
 * betöltés közben „…”, ismeretlen slugnál „ismeretlen”.
 */
export const productTypeChipLabel = (types: ProductTypeRef[] | null, slug: string): string => {
  if (types === null) return '…';
  return types.find((t) => t.slug === slug)?.name ?? 'ismeretlen';
};

/** Több kategória-slug egy `category_slug` paraméterben (vesszővel, duplikátum nélkül). */
export const categorySlugParam = (slugs: string[]): string =>
  Array.from(new Set(slugs.map((s) => s.trim()).filter(Boolean))).join(',');
